<template>
    <div class="app-container">
        <el-form v-if="search" :model="query" ref="form" size="small" inline @submit.native.prevent>
            <slot name="filters"></slot>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch"> 查询 </el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"> 清空 </el-button>
            </el-form-item>
        </el-form>
        <el-row type="flex" justify="space-between">
            <div></div>
            <el-row type="flex">
                <slot name="btns"></slot>
            </el-row>
        </el-row>
        <el-row>
            <el-table
				row-key="uuid"
                ref="table"
                header-cell-class-name="table-header"
                border
                v-bind="$attrs"
                @selection-change="handleSelectionChange"
                style="margin: 20px 0"
            >
                <slot name="columns"></slot>
            </el-table>
            <el-row v-if="page" type="flex" justify="end">
                <el-pagination v-on="$listeners" :current-page="query.page_index" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </el-row>
        </el-row>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        query: {
            type: Object,
            default: () => ({}),
        },
        total: {
            type: Number,
            default: 0,
        },
        search: {
            type: Boolean,
            default: true,
        },
        page: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        handleSearch() {
            this.$emit("search");
        },
        resetQuery() {
            this.$refs.form.resetFields();
            this.$emit("reset");
        },
        handleSelectionChange(row) {
            this.$emit("selection-change", row);
        },
        getTableRef() {
            return this.$refs.table;
        },
    },
};
</script>

<style></style>
